import React from 'react'

// tslint:disable-next-line
export const RasaContext = React.createContext({
  accountInfo: null,
  canSpamInfo: null,
  emailPreferenceInfo: null,
  setAccountInfo: null,
  setCanSpamInfo: null,
  setEmailPreferenceInfo: null,
  store$: null,
  history$: null,
  store: null,
  action$: null,
})
